import React, { useRef, useState } from 'react';

import * as digitalData from '@ao-internal/digital-data';

import { useEventListener } from '../../../hooks/useEventListener';
import { checkKeyEvent } from '../../../utilities/form-utilities';
import { isTouchScreenDevice } from '../../../utilities/lister-utilities';
import TRANSLATIONS from './translations@default.json';

const TrendingBrandsToolTip = () => {
	const ref = useRef(null);
	const [open, setOpen] = useState(false);

	const isTouchScreen = isTouchScreenDevice();

	const getWidth = () => {
		return window.innerWidth - 32;
	};

	const sendHoverTracking = (isHovered) => {
		if (!isTouchScreen) {
			setOpen(isHovered);

			// Hover events are currently not supported in new tracking library
			digitalData.sendBeacon('TrackHover', {
				name: 'exposed_facets_tooltip_hover',
				hovered: isHovered,
				type: 'hover',
			});
		}
	};

	const handleScroll = () => {
		setOpen(false);
	};

	const closeTooltip = () => setOpen(false);

	useEventListener('scroll', handleScroll);

	useEventListener('closeTrendingBrandsTooltip', closeTooltip);

	return (
		<div ref={ref} className="relative">
			<button
				type="button"
				className="bg-transparent rounded-md"
				data-testid="tooltip_button"
				data-tag-name="exposed_facets_tooltip_open_button"
				onKeyPress={(evt) =>
					checkKeyEvent(evt, 'Enter', () => {
						setOpen((isOpen) => !isOpen);
					})
				}
				onClick={() => setOpen((isOpen) => !isOpen)}
				onMouseEnter={() => sendHoverTracking(true)}
				onMouseLeave={() => sendHoverTracking(false)}
				onBlur={() => setOpen(false)}>
				<title id="tooltip_icon">Search</title>
				<i
					id="trending_brands_tooltip"
					role="img"
					aria-describedby="tooltip_icon"
					className="ico ico-product-info ico-2x text-water"
				/>
				{open && (
					<div
						className="absolute right-0 bottom-0 flex"
						style={{
							width: `${getWidth()}px`,
							maxWidth: '350px',
							zIndex: '100',
						}}>
						<div className="bg-white p-4 rounded-md shadow-4dp mb-8">
							<div className="flex items-center justify-between w-full pb-2">
								<div className="text-title">{TRANSLATIONS.title}</div>
								{isTouchScreen && (
									<div
										role="button"
										tabIndex="0"
										className="bg-transparent rounded-md z-10"
										data-testid="tooltip_close_button"
										data-tag-name="exposed_facets_tooltip_close_button"
										onKeyPress={(evt) =>
											checkKeyEvent(evt, 'Enter', () => {
												evt.stopPropagation();
												setOpen(false);
											})
										}
										onClick={(evt) => {
											evt.stopPropagation();
											setOpen(false);
										}}>
										<i className="ico ico-close ico-lg text-cta-action" />
									</div>
								)}
							</div>
							<p className="text-body-sm text-tertiary text-left">
								{TRANSLATIONS.toolTip}
							</p>
						</div>
					</div>
				)}
			</button>
		</div>
	);
};

export default TrendingBrandsToolTip;
